import React, { useEffect, useState } from "react";
import Webmenu from "../../../layouts/webmenu";
import Topbar from "../../../layouts/topbar";
import { useDispatch, useSelector } from "react-redux";
import { getAllCustomerType, toggleCustomerType } from "../../../actions/CustomerTypeActions";
import { Link } from "react-router-dom";
import { getAllInsuranceCompany, getInsuranceCompanyById, toggleInsuranceCompany } from "../../../actions/InsuranceCompanyActions";
import AddInsuranceCompanies from "./addInsurance";
import DataTable from "react-data-table-component";
import { ThreeDots } from "react-loader-spinner";
import Select from 'react-select';
import { styleSelect } from "../../../constants/customStyles";
import Mobilemenu from "../../../layouts/mobile-menu";


function InsuranceCompanies() {

    const dispatch = useDispatch();

    // useEffect(() => {
    //     return () => {
    //         dispatch(getAllInsuranceCompany());
    //     }
    // }, [])

    const [page, setPage] = useState(1);
    const [currentRowsPerPage, setCurrentRowsPerPage] = useState(10);
    const [modalType, setModalType] = useState('add');
    const [paginationTotalRows, setPaginationTotalRows] = useState(0);

    const insuranceCompanies = useSelector(state => state?.insuranceCompany?.insuranceCompanies?.data);
    const editinsuranceCompanies = useSelector(state => state?.insuranceCompany?.insuranceCompany);
    const insuranceCompaniesPaginate = useSelector(state => state?.insuranceCompany?.insuranceCompanies?.total);
    const loading = useSelector(state => state?.loading?.loading);

    const onClickEdit = (id) => {
        setModalType('edit');
        dispatch(getInsuranceCompanyById(id));
    }

   useEffect(() => {
            dispatch(getAllInsuranceCompany(page, currentRowsPerPage, filter ?? ''));
       }, [currentRowsPerPage])

    const onChangePage = (page) => {
        dispatch(getAllInsuranceCompany(page, currentRowsPerPage, filter ?? ''));
    }

    const toggleStatus = (id) => {
        dispatch(toggleInsuranceCompany(id));
    }

    const customStyles = {
        table: {
            style: {
                backgroundColor: 'rgb(241, 245, 248)',
            },
        },
        headRow: {
            style: {
                border: 'none !important'
            }
        },
        head: {
            style: {
                fontWeight: 'bold',
                fontSize: '14px',
                border: 'none !important',
            }
        },
        rows: {
            style: {
                minHeight: '60px', // override the row height
                backgroundColor: '#fff !important',
                borderTop: 'none !important',
                marginBottom: '10px',
                borderRadius: '30px',
                paddingRight: '5px',
                '&:not(:last-of-type)': {
                    border: 'none'
                }
            },
        },
        body: {
            style: {
                backgroundColor: 'rgb(241, 245, 248)',
            }
        },
        headCells: {
            style: {
                paddingLeft: '20px', // override the cell padding for head cells
                paddingRight: '20px',
                fontSize: '14px',
                fontWeight: '700',
                textTransform: 'uppercase',
                border: 'none !important',
                backgroundColor: 'rgb(241, 245, 248)',
                // justifyContent: 'center'
            },
        },
        cells: {
            style: {

                fontSize: '14px',
                // 'div:first-child': {
                //     overflow: 'visible !important'
                // }
                // justifyContent: 'center'
            },
        },
        pagination: {
            style: {
                backgroundColor: 'rgb(241,245,248)',
                borderTop: 'none !important',
            },
        }
    };

    const columns = [
        {
            name: 'ID',
            selector: row => row.insurance_company_id,
            // width: '150px'
        },
        {
            name: 'NAME',
            selector: row => row.name,
            // width: '500px',
        },
        {
            name: 'TRN NO.',
            selector: row => row.vat,
            // width: '500px',
        },
        // {
        //     name: 'VAT #',
        //     selector: row => row?.tax_reg_no,
        //     // width: '500px',
        // },
        // {
        //     name: 'STATUS',
        //     selector: row => <div className="d-flex align-items-center form-check form-switch">
        //         <input onChange={(e) => toggleStatus(row.id)} type="checkbox"
        //             defaultChecked={row.active} className="form-check-input" />
        //     </div>,
        // },
        {

            selector: row => {
                return (<>
                    <div className="dropdown">
                        <button className="dropdown-toggle btn px-2 box text-gray-700 dark-text-gray-300" aria-expanded="false" data-bs-toggle="dropdown">
                            <span className="d-flex align-items-center fs-base justify-content-center">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-settings me-1 w-6 h-6"><circle cx="12" cy="12" r="3"></circle><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path></svg>
                                Actions
                            </span>
                        </button>
                        <div className="dropdown-menu w-40">
                            <div className="dropdown-content">
                                <Link data-bs-toggle="modal" data-bs-target="#add-modal" className="d-flex align-items-center me-5" onClick={() => onClickEdit(row.insurance_company_id)}> <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-edit me-1 w-6 h-6"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path></svg> Edit </Link>
                            </div>
                        </div>
                    </div>
                </>)
            },
        },
    ];

    const [filter, setFilter] = useState('');

    const handleFilter = (event) => {
        setFilter({
            ...filter,
            [event.target.name]: event.target.value,
        })
    }
    const handleFilterstatus = (event) => {
        setFilter({
            ...filter,
            status: event.value,
            statuslabel: event.label,
        })
    }
    // 
    const handleClearFilter = () => {
        setFilter('')
        dispatch(getAllInsuranceCompany(page, currentRowsPerPage, ''))
    }

    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            filterSearch();
        }
    }

    const filterSearch = () => {
        dispatch(getAllInsuranceCompany(page, currentRowsPerPage, filter ?? ''))
    }




    return (
        <React.Fragment>
            <Mobilemenu />
            <div className="content-body d-flex">
                <Webmenu />
                <div className="content">
                    <Topbar />
                    <span>
                        <h2 className="intro-y fs-lg fw-medium mt-10">
                            Insurance Companies
                        </h2>
                        <div className="intro-y g-col-12 d-flex flex-wrap flex-sm-nowrap align-items-center justify-content-between mt-2">
                            <button data-bs-toggle="modal" onClick={() => setModalType('add')} data-bs-target="#add-modal" className="btn btn-primary shadow-md me-2">Add New</button>
                            <button class="btn btn-primary ms-auto d-flex align-items-center dark-text-theme-10" type="button"
                                data-bs-toggle="collapse" data-bs-target="#faq-accordion-collapse-1" aria-expanded="true"
                                aria-controls="faq-accordion-collapse-1">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-filter w-4 h-4 me-3"><polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon></svg>
                                Filters </button>
                        </div>
                        <div id="faq-accordion-collapse-1" class="accordion-collapse collapse show mt-5" aria-labelledby="faq-accordion-content-1"
                            data-bs-parent="#faq-accordion-1">
                            <div class="grid columns-12 gap-6 mt-5">
                                <div class="intro-y g-col-12 g-col-lg-12">
                                    <div class="intro-y box p-5">
                                        <div class="row">

                                            <div class="col-lg-3 col-md-6">
                                                <div>
                                                    <label for="crud-form-1" class="form-label font-weight-bold">Name</label>
                                                    <input id="crud-form-1" type="text" onKeyPress={handleKeyPress} onChange={handleFilter} value={filter?.name ?? ''} name="name"
                                                        class="form-control w-full" placeholder="Enter Name" />
                                                </div>
                                            </div>
                                            <div className="col-lg-3 col-md-6">
                                                <label for="pay_type" className="form-label">Status </label>
                                                <Select styles={styleSelect} value={{ value: filter?.status, label: filter?.statuslabel }} onChange={handleFilterstatus} name="status" options={[{ value: 1, label: "Active" }, { value: 0, label: "Inactive" }]} />
                                            </div>
                                        </div>
                                        <div class="text-end mt-5">
                                            <button type="submit" class="btn btn-elevated-primary w-24 me-2" onClick={() => filterSearch()}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-search w-4 h-4 me-2"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>
                                                Search</button>
                                            <button onClick={handleClearFilter} type="button" class="btn btn-elevated-danger w-24"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x w-4 h-4 me-2"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg> Clear</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>


                        {/* <!-- BEGIN: Data List --> */}
                        <div className="intro-y g-col-12">
                            <div className='mt-2'>
                            <DataTable
                                    // title="Users"
                                    className="overflow-lg-visible"
                                   columns={columns}
                                    data={insuranceCompanies && insuranceCompanies.length > 0 ? insuranceCompanies : []}
                                    progressPending={loading}
                                    progressComponent={<ThreeDots
                                        height="80"
                                        width="80"
                                        radius="9"
                                        color="#2d3748"
                                        ariaLabel="three-dots-loading"
                                        wrapperStyle={{ justifyContent: 'center', alignItems: 'center', height: '100%' }}
                                        wrapperClassName=""
                                        visible={loading}
                                    />}
                                    pagination
                                    paginationServer
                                    customStyles={customStyles}
                                    paginationTotalRows={insuranceCompaniesPaginate ? insuranceCompaniesPaginate : 0}
                                    onChangeRowsPerPage={(currentRowsPerPage) => setCurrentRowsPerPage(currentRowsPerPage)}
                                    onChangePage={(page) => onChangePage(page)}
                                />
                                {/* <DataTable
                                            className="overflow-lg-visible"
                                           columns={columns.map(column => ({
                                                    ...column,
                                                    cell: column.cell ? column.cell : (row) => (
                                                        <div>
                                                            {column.selector(row)}
                                                        </div>
                                                    ),
                                                }))}
                                            data={insuranceCompanies && insuranceCompanies.length > 0 ? insuranceCompanies : []}
                                            striped={true}
                                            highlightOnHover={true}
                                            pagination={true}
                                            customStyles={customStyles}
                                            responsive={true}
                                            paginationServer={true}
                                            paginationTotalRows={insuranceCompanies && insuranceCompanies.length > 0 ? insuranceCompaniesPaginate.total : 0}
                                            onChangePage={(page) => onChangePage(page)}
                                            paginationRowsPerPageOptions={[10, 20, 50, 100]}
                                            onChangeRowsPerPage={(currentRowsPerPage, currentPage) => setCurrentRowsPerPage(currentRowsPerPage)}
                                            paginationPerPage={10}
                                        /> */}
                            </div>

                            {/* <!-- END: Data List --> */}
                        </div>
                    </span>
                </div>
            </div>

            <AddInsuranceCompanies editinsuranceCompanies={editinsuranceCompanies} modalType={modalType} currentRowsPerPage={currentRowsPerPage} page={page} />
        </React.Fragment>
    )
}

export default InsuranceCompanies;